"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ramda_1 = require("ramda");

var apollo_link_1 = require("apollo-link");

var SuccessLink =
/*#__PURE__*/
function (_apollo_link_1$Apollo) {
  _inherits(SuccessLink, _apollo_link_1$Apollo);

  function SuccessLink(_ref) {
    var _this;

    var successHandler = _ref.successHandler;

    _classCallCheck(this, SuccessLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SuccessLink).call(this));
    _this.successHandler = successHandler;
    return _this;
  }

  _createClass(SuccessLink, [{
    key: "request",
    value: function request(operation, forward) {
      var _this2 = this;

      return new apollo_link_1.Observable(function (observer) {
        forward(operation).subscribe({
          complete: function complete() {
            return observer.complete.apply(observer, arguments);
          },
          error: function error() {
            return observer.error.apply(observer, arguments);
          },
          next: function next(data) {
            if (ramda_1.not(ramda_1.has('errors', data))) {
              _this2.successHandler({
                operation: operation,
                data: data
              });
            }

            observer.next(data);
          }
        });
      });
    }
  }]);

  return SuccessLink;
}(apollo_link_1.ApolloLink);

exports.SuccessLink = SuccessLink;